import { useEffect, useState, useContext, useRef} from 'react'
import {  Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import { AppContext } from "../../Context";
import Fetch, { Loader, Get, priceFormat } from "../inc/Fetch";
import Product from "../components/product/Product";
import ErrorPage from "./ErrorPage";

import { MdArrowForwardIos } from "react-icons/md";
import { FaSearch } from "react-icons/fa";

import Header from "./Header";
import Footer from "./Footer";

// ads

import './css/Cats.css'

export default function Search() {

    const { t } = useTranslation();
    let ref = useRef();
    let refSearch = useRef("");
    const params = useParams();

    
	const {siteData} = useContext(AppContext); 
	const [siteInfo, setsiteInfo] = siteData;
    
    const [loader, setloader] = useState(false);
    const [data, setdata] = useState([]);
    const [search, setsearch] = useState("");
    const [sort, setsort] = useState('date');
    const [isFetching, setisFetching] = useState(false);

    let page = useRef(1);
    let scrollAllow = useRef(true);

    let idRef = useRef("");
    let sortRef = useRef(sort);


    async function loadData() {
        page.current = 1;
        let res = await Fetch('cats', { sort:sort, search: refSearch.current, page:"search" });
        setdata(res);
        setloader(false);
        return res;
    }

    async function loadMore() {
        
        
        setisFetching(true);
        let res = await Fetch('cats', { sort:sort, search: refSearch.current, page:"search", sort:sortRef.current, page:page.current });
        
        setdata(prevData => ({
            ...prevData,
            products: [...prevData.products, ...res.products],
        }));
        
        page.current = page?.current + 1; 

        setisFetching(false);
        if (res?.products?.length) {
            setTimeout(() => {
                scrollAllow.current = true;
            }, 1000);
        }
    }

    async function submit(e) {
        e.preventDefault();

        setloader(true);

        loadData();
    }

    useEffect(() => {

        if (sort) {
            let getEl = document.getElementById("mainBodyData");
            getEl.scrollTo(0, 0);
            loadData();
        }
      
    }, [params?.id]);

    const handleScroll = (e) => {

        if (siteInfo?.settings?.paging?.val) {
            return false;
        }

        let vals = {};
        vals.scrollTop = e?.target?.scrollTop;
        vals.scrollHeight = e?.target?.scrollHeight;
        vals.clientHeight = e?.target?.clientHeight;

        if (window?.innerWidth < 700) {

            let getEl = document.querySelector("footer");

            vals.scrollTop = window.scrollY;
            vals.scrollHeight = getEl?.getBoundingClientRect().top + window.scrollY;
            vals.clientHeight = window.outerHeight;
        }

        if (scrollAllow.current) {
            let trig = vals.scrollHeight - vals.clientHeight - vals.scrollTop - 400;
            
            if (trig <= 0) {
                
                loadMore();
                scrollAllow.current = false;
                
            }
        }
        
    }

    
    useEffect(() => {
        
        let getEl = document.getElementById("mainBodyData");
        if (getEl?.clientWidth < 700) {
            getEl = window;
        }
        setTimeout(() => {
            getEl.addEventListener('scroll', handleScroll);
        }, 1000);

        return () => {
            getEl.removeEventListener('scroll', handleScroll)
        }
    }, []);



    // if (loader) {
    //     return <Loader />;
    // }

    if (data?.error) {
        return <ErrorPage />
    }

    

	return (
		<>
            {loader && <Loader />}
            <Helmet>
                <title>{t("search")}</title>
                <meta property="og:title" content={data?.cat?.name} />
            </Helmet>

			<Header title={true} /> 

            <div className={`effect inside search`}>

                <div className='blend'></div>
                <form onSubmit={submit} className='mainWidth searchBox'>
                    <input type='search' onChange={d => refSearch.current = d?.target?.value} autoFocus placeholder={`${t("search")}...`} />
                    <button ><FaSearch /></button>
                </form>
                
            </div>

            <nav className='mainWidth pathNames search'> 
                <Link to='/'>{t("home")}</Link>
                <MdArrowForwardIos />
                <Link to='/cat'>{t("all_products")}</Link>
                <MdArrowForwardIos />
                <Link>{t("search")}</Link>
                <MdArrowForwardIos />
                <Link>{search}</Link>
            </nav>

        

            <div className='mainWidth ' style={{marginBottom:40,}}>

                <div className='homeTopProducts' style={{padding:0}}>

                    <div className='filterBox'>
                        <span>
                            {data?.search && 
                            <>
                                {t("products_res")} <b>{data?.info?.count}</b> 
                            </>}
                        </span>

                        <select onChange={(e) => setsort(e.target.value)} name='sort'>
                            <option value='date'>{t("sort_by_1")}</option>
                            <option value='sold'>{t("sort_by_2")}</option>
                            <option value='price'>{t("sort_by_3")}</option>
                            <option value='price2'>{t("sort_by_4")}</option>
                        </select>
                    </div>


                    <div className='productsBox list5' style={{marginTop:0, padding:20}}>
                        {data?.products?.length ? data?.products?.map((v, k) => {
                            return (
                                <Product data={v} key={k} /> 
                            );
                        }): <div className='noData'>{data?.search ? t("search_no_data") : t("search_first")}</div>}

                    </div>
        
                </div>

                
       

            </div>
            
            <Footer />
		</>
	)
}
